import React from 'react';
import { Dialog, DialogContent, DialogTitle, Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { teal } from '../constants';

interface UnapprovedSchoolAlertProps {
    open: boolean;
}

const UnapprovedSchoolAlert: React.FC<UnapprovedSchoolAlertProps> = ({ open }) => {
    const classes = useStyles();

    return (
        <Dialog
            open={open}
            disableEscapeKeyDown
            disableBackdropClick
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle className={classes.title}>
                <Typography variant="h5" className={classes.titleText}>
                    בית הספר טרם אושר
                </Typography>
            </DialogTitle>
            <DialogContent className={classes.content}>
                <Box className={classes.messageBox}>
                    <Typography variant="body1" className={classes.message}>
                        בית הספר שלך טרם אושר על ידי מנהל המערכת.
                    </Typography>
                    <Typography variant="body1" className={classes.message}>
                        אנא המתן לאישור לפני שתוכל להשתמש במערכת.
                    </Typography>
                    <Typography variant="body2" className={classes.subMessage}>
                        תקבל הודעה כאשר בית הספר יאושר.
                    </Typography>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

const useStyles = makeStyles({
    title: {
        backgroundColor: teal,
        color: 'white',
        textAlign: 'center',
        padding: '20px',
    },
    titleText: {
        fontWeight: 'bold',
    },
    content: {
        padding: '30px',
        textAlign: 'center',
    },
    messageBox: {
        display: 'flex',
        flexDirection: 'column',
        gap: '15px',
    },
    message: {
        fontSize: '18px',
        fontWeight: 500,
        lineHeight: 1.6,
    },
    subMessage: {
        fontSize: '14px',
        color: '#666',
        marginTop: '10px',
    },
});

export default UnapprovedSchoolAlert;
